import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { paymentSelectors } from '@makemydeal/dr-offer-redux';
import { featureToggleSelectors, type ReduxNext, type ReduxStore } from '@makemydeal/dr-shared-store';

import * as dueAtSigningActionCreators from '../actions/dueAtSigningActionCreators';
import * as dueAtSigningSelectors from '../selectors/dueAtSigningSelectors';
import { applyDasChanges } from '../actions/dueAtSigningActionCreators';
import { PAYMENT_FAILURE, PAYMENT_RECEIVED } from '../actionTypes/deskingActionTypes';
import {
    APPLY_DUE_AT_SIGNING,
    DAS_UPDATE_DOWNPAYMENT,
    DAS_UPDATE_EQUITY_ALLOCATION_METHOD,
    DAS_UPDATE_FEES_CAPITALIZED,
    DAS_UPDATE_FIRSTPAYMENT,
    DAS_UPDATE_TARGET_CASH_AMOUNT_PAID,
    DAS_UPDATE_TAXES_CAPITALIZED,
    DUE_AT_SIGNING_SLIDE_OUT_TOGGLE
} from '../actionTypes/dueAtSigningActionTypes';

let currentDasAbortController: AbortController | null = null;

export const middleware = (store: ReduxStore<StateTree>) => (next: ReduxNext) => async (action: AnyFSA) => {
    next(action);

    switch (action.type) {
        case DAS_UPDATE_DOWNPAYMENT:
        case DAS_UPDATE_FIRSTPAYMENT:
        case DAS_UPDATE_FEES_CAPITALIZED:
        case DAS_UPDATE_TAXES_CAPITALIZED:
        case DAS_UPDATE_EQUITY_ALLOCATION_METHOD:
        case DAS_UPDATE_TARGET_CASH_AMOUNT_PAID: {
            if (currentDasAbortController) {
                currentDasAbortController.abort();
            }
            currentDasAbortController = new AbortController();
            store.dispatch(applyDasChanges(currentDasAbortController.signal));
            break;
        }

        case DUE_AT_SIGNING_SLIDE_OUT_TOGGLE: {
            if (currentDasAbortController) {
                currentDasAbortController.abort();
                currentDasAbortController = null;
            }
            break;
        }

        case PAYMENT_RECEIVED: {
            if (action.payload.actionForPayment === APPLY_DUE_AT_SIGNING) {
                currentDasAbortController = null;
                const state = store.getState();

                if (paymentSelectors.getIsError(state)) {
                    store.dispatch(dueAtSigningActionCreators.applyDueAtSigningError(action));
                } else {
                    store.dispatch(dueAtSigningActionCreators.applyDueAtSigningSuccess());
                }
            } else if (
                dueAtSigningSelectors.getIsSlideOutOpen(store.getState()) &&
                featureToggleSelectors.isDasPaymentRefreshEnabled(store.getState())
            ) {
                store.dispatch(dueAtSigningActionCreators.clearDasPayment());
                if (currentDasAbortController) {
                    currentDasAbortController.abort();
                }
                currentDasAbortController = new AbortController();
                store.dispatch(applyDasChanges(currentDasAbortController.signal));
            }

            break;
        }

        case PAYMENT_FAILURE: {
            currentDasAbortController = null;
            store.dispatch(dueAtSigningActionCreators.applyDueAtSigningError(action));
            break;
        }

        default:
            break;
    }
};
